<ng-container *ngIf="defaults?.type === 'delete'">
    <p>Are you sure want to delete ?</p>
    <div class="btn-sec">
      <button mat-button color="warn" style="margin-right: 10px;background: #c5c8ca;" mat-dialog-close="yes">Yes</button>
      <button mat-button color="warn" style="background: #c5c8ca;" mat-dialog-close="no">No</button>
    </div>
  </ng-container>

  <ng-container *ngIf="defaults?.type === 'cancel'">
    <p>Are you sure want to cancel?</p>
    <div class="btn-sec">
      <button mat-button color="warn" style="margin-right: 10px;background: #c5c8ca;" mat-dialog-close="yes">Yes</button>
      <button mat-button color="warn" style="background: #c5c8ca;" mat-dialog-close="no">No</button>
    </div>
  </ng-container>
  
  <ng-container *ngIf="defaults?.type === 'edit'">
    <app-page-layout mode="card">
      <app-page-layout-header [@fadeInRight]>
        <h2>Edit homeowner</h2>
      </app-page-layout-header>
  
      <app-page-layout-content [@fadeInUp]>
        <div class="Customer-Info">
          <div class="Customer-Details">
            <form [formGroup]="homeownerform" style="width: 100%;">
              <div>
                <h4>Homeowner Info</h4>
              </div>
              <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px"
                style="margin-bottom: 20px;align-items: baseline;">
                <mat-form-field style="margin-right: 16px;">
                  <mat-label>Title</mat-label>
                  <input matInput placeholder="Title" formControlName="title">
                  <mat-error
                    *ngIf="homeownerform.controls['title'].touched && homeownerform.controls['title'].hasError('required')">
                    This is a required field.</mat-error>
                </mat-form-field>
  
                <div>
                  <mat-label>Upload image</mat-label>
                  <input type="file" (change)="onImageUpload($event)" accept=".png, .jpg, .jpeg">
                  <p>{{this.homeownerform.controls['image'].value}}</p>
                  <mat-error
                    *ngIf="homeownerform.controls['image'].touched && homeownerform.controls['image'].hasError('required')">
                    This is a required field.</mat-error>
                </div>
              </fxLayout>
  
              <fxLayout fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px" style="margin-bottom: 20px;">
                <mat-form-field style="width: 100%;">
                  <mat-label>Description</mat-label>
                  <textarea matInput placeholder="Description" formControlName="description"
                    style="height: 60px;"></textarea>
                  <mat-error
                    *ngIf="homeownerform.controls['description'].touched && homeownerform.controls['description'].hasError('required')">
                    This is a required field.</mat-error>
                </mat-form-field>
              </fxLayout>
              <button (click)="edit()" style="margin-right:10px;">Save</button>
              <button mat-dialog-close="no">close</button>
            </form>
          </div>
        </div>
      </app-page-layout-content>
    </app-page-layout>
  
  </ng-container>
  
  <ng-container *ngIf="defaults?.type === 'delete-all'">
    <p>Are you sure want to delete your data?</p>
    <div class="btn-sec">
      <button mat-button color="warn" style="margin-right: 10px;background: #c5c8ca;" [mat-dialog-close]="confirmation.Yes">Yes</button>
      <button mat-button color="warn" style="background: #c5c8ca;" [mat-dialog-close]="confirmation.No">No</button>
    </div>
  </ng-container>

  <ng-container *ngIf="defaults?.type === 'deleteTimeSchedule'">
    <p class="text-center">Are you sure, you want to delete the time slot from <span class="red">{{defaults?.startTime}}</span> to <span class="red">{{defaults?.endTime}}</span>?</p>
    <div class="btn-sec">
      <button mat-button color="warn" style="margin-right: 10px;background: #022b01;" [mat-dialog-close]="confirmation.Yes">Yes</button>
      <button mat-button color="warn" style="background: #c5c8ca;" [mat-dialog-close]="confirmation.No">No</button>
    </div>
  </ng-container>

  <ng-container *ngIf="defaults?.type === 'resetSchedule'">
    <p>Are you sure, you want to delete all the schedule of <span class="red">{{defaults?.dayName}}</span>?</p>
    <div class="btn-sec">
      <button mat-button color="warn" style="margin-right: 10px;background: #c5c8ca;" [mat-dialog-close]="confirmation.Yes">Yes</button>
      <button mat-button color="warn" style="background: #c5c8ca;" [mat-dialog-close]="confirmation.No">No</button>
    </div>
  </ng-container>

  <ng-container *ngIf="defaults?.type === 'changeAgreementStatus'">
    <p>Are you sure, you want to change the payment status from pending to paid?</p>
    <div class="btn-sec">
      <button mat-button color="warn" style="margin-right: 10px;background: #c5c8ca;" [mat-dialog-close]="confirmation.Yes">Yes</button>
      <button mat-button color="warn" style="background: #c5c8ca;" [mat-dialog-close]="confirmation.No">No</button>
    </div>
  </ng-container>

  <ng-container *ngIf="defaults?.type === 'resetPartnerPassword'">
    <p>Are you sure, you want to reset the partner password?</p>
    <div class="btn-sec">
      <button mat-button color="warn" style="margin-right: 10px;background: #c5c8ca;" [mat-dialog-close]="confirmation.Yes">Yes</button>
      <button mat-button color="warn" style="background: #c5c8ca;" [mat-dialog-close]="confirmation.No">No</button>
    </div>
  </ng-container>
  
